module.exports = __webpack_public_path__ + "img/CPTemp13.1cd8f98e.png";